module.exports = __webpack_public_path__ + "media/assets/icons/monitoring-c01a58b625176ec4973d92b5843144ce.svg";